export default function umeTabs() {
  let umeTabContent = document.querySelectorAll('.ume-tabs__content >*');

  function fadeIn(element, duration) {
    let targetOpacity = 1;
    let startOpacity = 0;
    let startTime = performance.now();
    element.style.display = 'block';

    function updateOpacity() {
      let currentTime = performance.now();
      let elapsed = currentTime - startTime;
      let progress = elapsed / duration;

      if (progress < 1) {
        element.style.opacity = startOpacity + progress * (targetOpacity - startOpacity);
        requestAnimationFrame(updateOpacity);
      } else {
        element.style.opacity = targetOpacity;
      }
    }

    updateOpacity();
  }
  
  function fadeOut(element, duration) {
    let targetOpacity = 0;
    let startOpacity = 1;
    let startTime = performance.now();

    function updateOpacity() {
      let currentTime = performance.now();
      let elapsed = currentTime - startTime;
      let progress = elapsed / duration;

      if (progress < 1) {
        element.style.opacity = startOpacity - progress * (startOpacity - targetOpacity);
        requestAnimationFrame(updateOpacity);
      } else {
        element.style.opacity = targetOpacity;
        element.style.display = 'none';
      }
    }

    updateOpacity();
  }
  
  if (umeTabContent) {
    for(let item of umeTabContent) {
      let btnValue = item.getAttribute('data-btn-value');
      let btnId = item.getAttribute('data-btn-id');

      let btn = document.createElement('button');
      btn.classList.add('btn');
      btn.setAttribute('aria-controls', btnId);
      btn.innerText = btnValue;
      item.closest('.ume-tabs').querySelector('.ume-tabs__buttons').appendChild(btn);

      btn.addEventListener('click', function () {
        let ariaControls = btn.getAttribute('aria-controls');

        if (btn.classList.contains('btn-active')) {
          return;
        }

        btn.parentNode.querySelector('.btn-active').classList.remove('btn-active');
        btn.classList.add('btn-active');

        fadeOut(item.closest('.ume-tabs').querySelector('.ume-tabs__content-inner.is-active'), 250);
        item.closest('.ume-tabs').querySelector('.ume-tabs__content-inner.is-active').classList.remove('is-active')

        fadeIn(item.closest('.ume-tabs').querySelector(`.ume-tabs__content-inner[data-btn-id="${ariaControls}"]`), 250);
        item.closest('.ume-tabs').querySelector(`.ume-tabs__content-inner[data-btn-id="${ariaControls}"]`).classList.add('is-active');
      })
    }

    for(let item of umeTabContent) {
      item.closest('.ume-tabs').querySelector('.ume-tabs__buttons .btn:first-child').classList.add('btn-active');
      item.closest('.ume-tabs').querySelector('.ume-tabs__content >*:first-child').classList.add('is-active');

      fadeIn(item.closest('.ume-tabs').querySelector('.ume-tabs__content >*:first-child'), 250);
    }
  }
}